"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExcludeKeywordFilter = void 0;
const lodash_1 = require("lodash");
/**
 * 除外キーワードを含むイベントを除外する
 */
class ExcludeKeywordFilter {
    static filter({ events, excludeKeywords }) {
        if ((0, lodash_1.isEmpty)(excludeKeywords)) {
            return events;
        }
        // タイトルに全てのキーワードが含まれていない予定のみを抽出
        return events.filter((event) => !excludeKeywords.some((k) => event.title.includes(k)));
    }
}
exports.ExcludeKeywordFilter = ExcludeKeywordFilter;
//# sourceMappingURL=excludeKeywordFilter.js.map